// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'core-js/es6/promise'
// import 'core-js/es6/string'
// import 'core-js/es7/array'

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

// Client
const envAppClientData = process.env.VUE_APP_CLIENT
const CLIENT = (typeof envAppClientData === 'undefined' || envAppClientData === 'default') ? 'cuiaba' : envAppClientData
const clientData = require(`@/data/${CLIENT}/ClientData.json`)

// adding EventBus
let EventBus = new Vue()
export default {store, EventBus, tableConfig, CLIENT, clientData}

import Vuelidate from 'vuelidate'
import vueTrees from 'vue-trees'
import store from './store'

var baseURL = process.env.VUE_APP_BASE_API_URL.replace(/\/$/, '')

// apenas pra acesso via VPN
if (window.location.hostname == 'vpn.tce.al.gov.br') {
  let address = window.location.href.indexOf('/admin')
  baseURL = window.location.href.substring(0, address) + '/backend/api'
}

axios.defaults.baseURL = baseURL
axios.defaults.headers.common = {
  'Accept': 'application/json'
}

import './services/message_handler'
// VueLoading
import './services/loading_handler'
// Table Config
import tableConfig from './config/table'

import './mixins/general_mixin'

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(vueTrees)
Vue.router = router

// vue authentication
Vue.use(VueAxios, axios)
Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x'),
  refreshData: {enabled: false}
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})
